// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29H1Z","colBig":"styles_colBig__3PEht","colSmall":"styles_colSmall__14BkY"};